export default "__VITE_ASSET__18f70431__"